export const environment: any = 'prod';
export const idleTimeout: any = '1200';
export const serviceUrl: any = environment == 'local' ? 'http://localhost/JaxLogt.coj.net' : environment == 'dev' ? 'https://dev-jobsforjax.coj.net' : environment == 'qa' ? 'https://qa-jobsforjax.coj.net' : environment == 'prod' ? 'https://jobsforjax.coj.net' : '';





